import { render } from "./schoolSafeVideo.vue?vue&type=template&id=e774c3a2&scoped=true"
import script from "./schoolSafeVideo.vue?vue&type=script&lang=js"
export * from "./schoolSafeVideo.vue?vue&type=script&lang=js"

import "./schoolSafeVideo.vue?vue&type=style&index=0&id=e774c3a2&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e774c3a2"]])

export default __exports__